import Spinner from "react-bootstrap/Spinner";
import "../Style/ProductModal.css";

function Loading() {
  return <Spinner animation="border" variant="warning" />;
}

export default Loading;
